import useBreakpointBase from "use-breakpoint";
import { BREAKPOINTS } from "../configs";

export const useBreakPoint = (breakpoints = BREAKPOINTS) => {
  return useBreakpointBase(breakpoints, "mobile");
};
